module.exports = __webpack_public_path__ + "img/3x BS-PD.41491339.svg";